// extracted by mini-css-extract-plugin
export default {"description":"Description_description__uQJRT","justify":"Description_justify__vw5Hf"};